const hideAllSlides = itemElement => {
  const allSiblingItems = itemElement.siblings();
  const actionElement = allSiblingItems.find(".js-ui-accordion-item");
  const bodyElement = allSiblingItems.find(".ui-accordion__body");

  actionElement.attr("aria-expanded", false);
  bodyElement.attr("aria-hidden", "true").slideUp(200);
  allSiblingItems.removeClass("is-active");
  allSiblingItems.find(".ui-accordion__icon-more").show();
  allSiblingItems.find(".ui-accordion__icon-less").hide();
};

const toggleSlide = itemElement => {
  const actionElement = itemElement.find(".js-ui-accordion-item");
  const bodyElement = itemElement.find(".ui-accordion__body");
  const newAttrValue =
    actionElement.attr("aria-expanded") === "true" ? "false" : "true";
  const bodyAttrValue =
    bodyElement.attr("aria-hidden") === "true" ? "false" : "true";

  actionElement.attr("aria-expanded", newAttrValue);
  bodyElement.attr("aria-hidden", bodyAttrValue).slideToggle(200);
  itemElement.toggleClass("is-active");
  itemElement.find(".ui-accordion__icon-more").toggle();
  itemElement.find(".ui-accordion__icon-less").toggle();
  return false;
};

const initUiAccordion = () => {
  $(".js-ui-accordion-item")
    .off()
    .on("click", function(event) {
      event.preventDefault();
      hideAllSlides($(this).closest(".ui-accordion__item"));
      toggleSlide($(this).closest(".ui-accordion__item"));
    })
    .on("keydown", function(event) {
      if (event.which === 32 || event.which === 13) {
        event.preventDefault();
        hideAllSlides($(this).closest(".ui-accordion__item"));
        toggleSlide($(this).closest(".ui-accordion__item"));
      }
    })
    .on("focus", function() {
      $(this)
        .closest(".ui-accordion__item")
        .addClass("is-focused");
    })
    .on("blur", function() {
      $(this)
        .closest(".ui-accordion__item")
        .removeClass("is-focused");
    });
};

export default initUiAccordion;
